import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69e8781163911b0014514f28/studymate/src/app/sign-up-login-screen/components/AuthScreen.tsx");
